import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primeicons/primeicons.css";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { CommonConfig } from "../../CommonConfig.js";
import api from "../../utils/api";
import cogoToast from "cogo-toast";
import APIConstant from "../../utils/constant";
// import { FilterMatchMode } from 'primereact/api';
import { InputSwitch } from "primereact/inputswitch";
import { Dropdown } from "primereact/dropdown";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

let configList = [
  {
    label: "Expiry Alert Config",
    value: "Expiry Alert Config",
  },
];

const AlertConfig = (props) => {
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState(null);
  const [filters, setFilters] = useState({
    global: { value: null },
  });
  const [globalFilter, setGlobalFilter] = useState("");
  const [configAlertId, setConfigAlertId] = useState(null);
  const [configAlertList, setConfigAlertList] = useState([]);
  const [isDeleteMaster, setIsDeleteMaster] = useState(false);
  const [isAddMaster, setIsAddMaster] = useState(false);
  const [isViewMaster, setIsViewMaster] = useState(false);
  const [viewMasterData, setViewMasterData] = useState({});

  const [configName, setConfigName] = useState("");
  const [configNameErr, setConfigNameErr] = useState(false);
  const [configNameErrText, setConfigNameErrText] = useState("");

  const [alertBeforeDays, setAlertBeforeDays] = useState("");
  const [alertBeforeDaysErr, setAlertBeforeDaysErr] = useState(false);
  const [alertBeforeDaysErrText, setAlertBeforeDaysErrText] = useState("");
  const [checked, setChecked] = useState(false);

  const actionBodyTemplateSrNo = (data, props) => {
    return props.rowIndex + 1;
  };
  const alertBodyTemplate = (data, props) => {
    return data.Checked == 1 ? "Yes" : "No";
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <>
        <div className="p-d-flex p-ai-center">
          <InputSwitch
            className="e-check-box p-mt-2"
            checked={rowData?.IsActive == 1 ? true : false}
            onChange={(e) => UpdateStatus(e, rowData)}
          />
          <Button
            className="e-add-btn"
            onClick={() => handleOpen(rowData, "EditMaster")}
            tooltip={"Edit"}
            tooltipOptions={{ className: "bluegray-tooltip", position: "top" }}
          >
            <i className="icon-editImage"></i>
          </Button>

          <Button
            className="e-add-btn"
            onClick={() => handleOpen(rowData, "DeleteMaster")}
            tooltip={"Delete"}
            tooltipOptions={{ className: "bluegray-tooltip", position: "top" }}
          >
            <i className="icon-delete"></i>
          </Button>
        </div>
      </>
    );
  };

  const UpdateStatus = async (e, rowData) => {
    setLoading(true);
    let data = {
      ConfigAlertId: rowData?.ConfigAlertId,
      UserId: userId,
      ConfigName: rowData?.ConfigName,
      AlertBeforeDays: rowData?.AlertBeforeDays,
      Checked: rowData?.Checked,
      IsActive: e.value == true ? 1 : 0,
    };
    try {
      api
        .post(APIConstant.path.AddUpdateAlertConfiguration, data)
        .then(async (res) => {
          const response = await res;
          if (response.Success === 1) {
            setLoading(false);
            cogoToast.success(response.Message);
            await resetScreen();
          } else {
            setLoading(false);
            cogoToast.error(response.Message);
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  useEffect(() => {
    let token = localStorage.getItem("Token");
    let data = localStorage.getItem("Infodata");
    if (token !== null) {
      setUserId(data);
      getConfigAlertList(data);
    } else {
      props.history.push("/login");
    }
    return () => {};
  }, []);

  const resetScreen = async () => {
    setConfigAlertId("");
    setConfigAlertList([]);
    setIsAddMaster(false);
    setIsDeleteMaster(false);
    setIsViewMaster(false);
    setConfigName("");
    setConfigNameErr(false);
    setConfigNameErrText("");
    setAlertBeforeDays("");
    setAlertBeforeDaysErr(false);
    setAlertBeforeDaysErrText("");
    setChecked(false);
    setLoading(false);
    await getConfigAlertList(userId);
  };

  const getConfigAlertList = async (UserId) => {
    try {
      setLoading(true);
      let data = {
        UserId,
      };
      await api
        .post(APIConstant.path.GetAlertConfiguration, data)
        .then(async (res) => {
          let response = await res;
          if (response.Success === 1) {
            setConfigAlertList(response.Data);
            setLoading(false);
          } else {
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          cogoToast.error(err);
        });
    } catch (err) {
      setLoading(false);
      cogoToast.error(err);
    }
  };

  const handleChange = (e, type) => {
    if (type == "configName") {
      if (CommonConfig.isEmpty(e.value)) {
        setConfigName("");
        setConfigNameErr(true);
        setConfigNameErrText("Config type is required");
      } else {
        setConfigName(e.value);
        setConfigNameErr(false);
        setConfigNameErrText("");
      }
    }
    if (type == "alertBeforeDays") {
      if (CommonConfig.isEmpty(e.target.value)) {
        setAlertBeforeDays("");
        setAlertBeforeDaysErr(true);
        setAlertBeforeDaysErrText("Days are required");
      } else {
        setAlertBeforeDays(e.target.value);
        setAlertBeforeDaysErr(false);
        setAlertBeforeDaysErrText("");
      }
    }
  };

  const validation = () => {
    let formIsValid = true;
    if (CommonConfig.isEmpty(configName)) {
      formIsValid = false;
      setConfigNameErr(true);
      setConfigNameErrText("Config is required");
    } else {
      setConfigNameErr(false);
      setConfigNameErrText("");
    }
    if (CommonConfig.isEmpty(alertBeforeDays)) {
      formIsValid = false;
      setAlertBeforeDaysErr(true);
      setAlertBeforeDaysErrText("Days are required");
    } else {
      setAlertBeforeDaysErr(false);
      setAlertBeforeDaysErrText("");
    }

    return formIsValid;
  };

  const handleOpen = async (item, type) => {
    if (type === "AddMaster") {
      setIsAddMaster(true);
    } else if (type === "EditMaster") {
      setIsAddMaster(true);
      setConfigAlertId(item.ConfigAlertId);
      setConfigName(item.ConfigName);
      setAlertBeforeDays(item.AlertBeforeDays);
      setChecked(item.Checked == 1 ? true : false);
    } else if (type === "DeleteMaster") {
      setConfigAlertId(item.ConfigAlertId);
      setIsDeleteMaster(true);
    } else if (type === "ViewMaster") {
      // setInsuranceCompanyMasterId(item.InsuranceCompanyMasterID);
      setIsViewMaster(true);
      setViewMasterData(item);
    }
  };

  const handleClose = async (type) => {
    if (type === "AddMaster") {
      setIsAddMaster(false);
      resetScreen();
    } else if (type === "EditMaster") {
      setIsAddMaster(false);
      setConfigAlertId(false);
      resetScreen();
    } else if (type === "DeleteMaster") {
      setConfigAlertList(null);
      setIsDeleteMaster(false);
      resetScreen();
    } else if (type === "ViewMaster") {
      setIsViewMaster(false);
      setViewMasterData({});
    }
  };

  const handleAddMaster = async (e) => {
    e.preventDefault();
    if (validation()) {
      setLoading(true);
      let data = {
        ConfigAlertId: configAlertId,
        UserId: userId,
        ConfigName: configName,
        AlertBeforeDays: alertBeforeDays,
        Checked: checked == true ? 1 : 0,
      };
      try {
        api
          .post(APIConstant.path.AddUpdateAlertConfiguration, data)
          .then(async (res) => {
            const response = await res;
            if (response.Success === 1) {
              setLoading(false);
              cogoToast.success(response.Message);
              await resetScreen();
            } else {
              setLoading(false);
              cogoToast.error(response.Message);
            }
          })
          .catch((err) => {
            setLoading(false);
            cogoToast.error(err);
          });
      } catch (err) {
        setLoading(false);
        cogoToast.error(err);
      }
    }
  };

  const handleDeleteMaster = async (Id) => {
    try {
      setLoading(true);
      let data = {
        UserId: userId,
        ConfigAlertId: configAlertId,
      };
      await api
        .post(APIConstant.path.DeleteAlertConfiguration, data)
        .then(async (res) => {
          let response = await res;
          if (response.Success === 1) {
            await resetScreen();
            setLoading(false);
          } else {
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          cogoToast.error(err);
        });
    } catch (err) {
      setLoading(false);
      cogoToast.error(err);
    }
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilter(value);
  };

  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard">
      <div className="heading-area p-d-flex p-ai-center p-jc-between p-pr-2 p-pl-3">
        <div className="p-d-flex p-ai-center">
          <i className="pi pi-filter-slash"></i>
          <h2>Config Alerts</h2>
        </div>
        <div className="p-ml-auto p-d-lg-flex p-ai-center">
          <span className="searchbar-area">
            <InputText
              type="search"
              onChange={onGlobalFilterChange}
              placeholder="Global Search"
              size="30"
            />
            <i className="icon-search"></i>
          </span>
        </div>
        <div className="card-actions">
          <Button
            type="button"
            className="e-add-btn"
            onClick={(e) => handleOpen(e, "AddMaster")}
          >
            <i className="icon-add"></i>
          </Button>
        </div>
      </div>
      <hr />
      <div className="custom-large-wb-table e-common-master-table">
        <DataTable
          filters={filters}
          className="main-table table-td"
          value={configAlertList}
          editMode="row"
          dataKey="id"
          responsiveLayout="scroll"
          paginator={true}
          rows={10}
          totalRecords={configAlertList.length}
          rowsPerPageOptions={CommonConfig.dataTableConfig.rowsPerPageOptions}
          emptyMessage="No records found"
          responsive={false}
          resizableColumns={true}
          columnResizeMode="fit"
          scrollable={true}
          scrollWidth="auto"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        >
          <Column
            field="Index"
            header="Sr.No"
            body={actionBodyTemplateSrNo}
            style={{ width: "5%" }}
          ></Column>
          <Column
            field="ConfigName"
            header="Config"
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="AlertBeforeDays"
            header="Alert Before Days"
            style={{ width: "10%" }}
          ></Column>
          <Column
            header="Every Day Alert"
            body={alertBodyTemplate}
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="Action"
            header="Action"
            body={actionBodyTemplate}
            headerStyle={{ width: "8%", minWidth: "8rem" }}
            bodyStyle={{ textAlign: "center" }}
          ></Column>
        </DataTable>
      </div>

      {/* Delete Confirm Modal */}
      <Dialog
        open={isDeleteMaster}
        className="stock-modal"
        onClose={(e) => handleClose("DeleteMaster")}
        fullWidth
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Delete Config</div>
          <div
            className="dialog-close"
            onClick={(e) => handleClose("DeleteMaster")}
          >
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent>
          <span>Are you sure want to delete the alert from system ?</span>
        </DialogContent>
        <DialogActions>
          <Button
            className="primary-btn1"
            onClick={(e) => handleClose("DeleteMaster")}
          >
            Cancel
          </Button>
          <Button
            className="primary-btn"
            onClick={(e) => handleDeleteMaster(configAlertId)}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add CutOff Alert */}
      <Dialog
        open={isAddMaster}
        className="stock-modal"
        onClose={(e) => handleClose("Add")}
        fullWidth
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>{configAlertId ? "Edit Alert" : "Add Alert"}</div>
          <div className="dialog-close" onClick={(e) => handleClose("Add")}>
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent>
          <GridContainer>
            <GridItem md={12}>
              <label>Config</label>
              <div className="p-d-flex p-ai-center">
                <Dropdown
                  className="p-w-100 p-mt-1"
                  id="configName"
                  placeholder="Select"
                  value={configName}
                  options={configList}
                  optionLabel="label"
                  onChange={(e) => handleChange(e, "configName")}
                  filter
                />
                <div>
                  {configName ? (
                    <Button
                      tabIndex={-1}
                      icon="pi pi-times"
                      className="p-button-rounded p-button-text p-button-danger p-mt-2"
                      onClick={() => {
                        setConfigName("");
                        setConfigNameErr(false);
                        setConfigNameErrText("");
                      }}
                    />
                  ) : null}
                </div>
                <span className="error-msg" style={{ color: "red" }}>
                  {configNameErr ? configNameErrText : null}{" "}
                </span>
              </div>
            </GridItem>
            <GridItem md={12}>
              <div className="p-mt-3">
                <label>Alert Before Days</label>
                <InputText
                  rows={4}
                  placeholder="Alert Before Days"
                  id="alertBeforeDays"
                  className="p-w-100 p-mt-1"
                  type="text"
                  value={alertBeforeDays}
                  maxLength={3}
                  onChange={(e) => handleChange(e, "alertBeforeDays")}
                />
                <span className="error-msg" style={{ color: "red" }}>
                  {alertBeforeDaysErr ? alertBeforeDaysErrText : null}{" "}
                </span>
              </div>
            </GridItem>
            <GridItem md={12}>
              <div className="p-d-flex p-ai-center p-my-3">
                <InputSwitch
                  checked={checked}
                  onChange={(e) => setChecked(e.value)}
                  className="p-ml-0"
                />
                <label className="p-ml-2">Everyday ?</label>
              </div>
            </GridItem>
          </GridContainer>
        </DialogContent>
        <DialogActions>
          <Button
            className="primary-btn1"
            onClick={(e) => handleClose("AddMaster")}
          >
            Cancel
          </Button>
          <Button className="primary-btn" onClick={(e) => handleAddMaster(e)}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AlertConfig;
